import { Link } from "react-router-dom";
import { volumes, chapters } from "@/mocks/manga";

function firstChapterId(volumeTitle: string) {
  const found = chapters.find((c) => c.volume === volumeTitle);
  return found ? found.id : "c1";
}

export default function Volumes() {
  const featured = volumes.slice(0, 6);
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">热门推荐</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              甜蜜惩罚漫画单行本全卷精选
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              从命运的相遇走向甜蜜终章，按卷顺序整理，点击即可进入对应卷的章节阅读。
            </p>
          </div>
          <Link
            to="/catalog"
            className="inline-flex items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-5 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看完整目录
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-6">
          {featured.map((v) => (
            <Link key={v.id} to={`/read/${firstChapterId(v.title)}`} className="group">
              <div className="relative overflow-hidden rounded-2xl bg-background-200/70">
                <img
                  src={v.cover}
                  alt={`${v.title} ${v.subtitle} 封面`}
                  className="aspect-[3/4] w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2.5 py-0.5 text-[10px] font-semibold text-background-50">
                  {v.tag}
                </span>
              </div>
              <div className="mt-3 px-0.5">
                <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600">
                  {v.title} <span className="font-normal text-foreground-500">{v.subtitle}</span>
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{v.count}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}